<!--
 * @Author: 熊伟
 * @Date: 2026-01-16 15:10:28
 * @Description:  用水条款说明
 * @LastEditors: 熊伟
 * @LastEditTime: 2026-01-19 16:39:51
 * @FilePath: /tongliao-nethall-h5-standard/src/views/Home/module/waterUsageTerms.vue
-->
<template>
  <div class="notice">
    <div class="notice-content">
      <div v-html="noticeHtml"></div>
    </div>
  </div>
</template>

<script>
import { getYSTKSMHtml } from '@/api/business';

export default {
  data() {
    return {
      noticeHtml:
        '<div id="u17" class="ax_default label">\n<div id="u17_text" class="text ">\n<p><span style="font-size: 14px;"><strong><span style="color: #000000;">报装须知</span><br /></strong></span></p>\n</div>\n</div>\n<div class="ax_default label"><strong><span style="font-size: 14px; color: #000000;">申报材料</span></strong></div>\n<div class="ax_default label">\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;">* 《申请表》</span></div>\n</div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;">* 申请用水之前请先点击下载申请附件，盖章后拍照上传。</span></div>\n<div class="ax_default label">&nbsp;</div>\n<div id="u19" class="ax_default" data-left="25" data-top="321" data-width="325" data-height="206">\n<div id="u23" class="ax_default _文本段落">\n<div id="u23_text" class="text ">\n<div class="ax_default label"><span style="font-size: 14px; color: #000000;"><span style="font-size: 14px;"><strong>注意事项</strong></span></span></div>\n\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">① </span>《居民用水申请表》用户自行打印，表内各项信息填写完整，用水客户签字处签字按手印，村委会及镇政府盖公章；<br /></span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">② </span>业务受理成功后，请保持手机畅通，工作人员将联系您进行现场勘查、缴费、签订合同事宜。<br /></span></div>\n<div class="ax_default label">&nbsp;</div>\n<div class="ax_default label"><span style="font-size: 14px; color: #000000;"><span style="font-size: 14px;"><strong>办理流程</strong></span></span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">① </span>提交申报材料至所属水厂<br /></span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">② </span>资料审核（如未通过需补交资料）<br /></span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">③ </span>现场勘查，确定用水方案</span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">④</span> 编制工程预算书<br /></span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">⑤ </span>用户缴费并签订供水合同</span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">⑥</span>设计施工</span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">⑦</span>验收通水</span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;"><span style="font-family: symbol;">⑧</span>办理水卡</span></div>\n<div class="ax_default label">&nbsp;</div>\n</div>\n</div>\n</div>\n<div id="u33" class="ax_default _文本段落">\n<div id="u33_div" class=""></div>\n<div id="u33_text" class="text ">\n<div class="ax_default label"><span style="font-size: 14px; color: #000000;"><span style="font-size: 14px;"><strong>申请人声明</strong></span></span></div>\n<div class="ax_default label"><span style="font-size: 14px; color: #969fa9;">本人已阅读并了解办事指南告知内容，同时承诺所提供资料真实有效。</span></div>\n</div>\n</div>\n<div class="ax_default label">&nbsp;</div>'
    };
  },
  computed: {},
  mounted() {
    this.getHTML();
  },
  methods: {
    // 获取用水条款说明
    async getHTML() {
      let res = await getYSTKSMHtml();
      let { status, resultData } = res;
      if (status === 'complete' && resultData) {
        this.noticeHtml = resultData.instructionContent;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.notice {
  display: flex;
  flex-direction: column;
  .notice-content {
    background: #ffffff;
    margin: 16px 0 80px 0;
    padding: 0 16px;
    overflow: hidden;
    /deep/ ul {
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
    }
    /deep/ ul ul {
      list-style-type: circle;
      margin-block-start: 0px;
      margin-block-end: 0px;
    }
    /deep/ul ul ul {
      list-style-type: square;
    }
    /deep/ol {
      list-style: decimal inside;
      padding-left: 40px;
      margin: 16px 0;
    }
  }
}
</style>
